import { GET_CUSTOMER_LIST, GET_CUSTOMER_LIST_FAIL, GET_CUSTOMER_LIST_SUCCESS } from '../types';

const initState = {
  customers: [],
  error: null,
  isLoading: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_LIST: {
      return { ...state, isLoading: true };
    }

    case GET_CUSTOMER_LIST_SUCCESS: {
      const { payload } = action;

      return { ...state, isLoading: false, customers: payload, error: null };
    }

    case GET_CUSTOMER_LIST_FAIL: {
      const { payload } = action;

      return { ...state, isLoading: false, customers: [], error: payload };
    }

    default:
      return state;
  }
};
